/**
  * dytejs v1.0.1-alpha
  * (c) 2021-2022 Tobithedev <ucheemekatobi@gmail.com>
  * https://github.com/dytejs/dytejs
  * Released under the MIT License.
*/
function tip() {
  console.warn('[Dyte Tips]: ', arguments[0]);
}
let Dative;
function setDative(_Dative) {
  Dative = _Dative;
}
function assert(condition, msg) {
  {
    if (!condition) { throw new Error(`[Dyte err] ${msg}`) }
  }
}
function isObject(obj) {
  return obj !== null && typeof obj === 'object'
}
/**
 * Validate whether given map is valid or not
 * @param {*} map
 * @return {Boolean}
 */
function isValidMap(map) {
  return Array.isArray(map) || isObject(map)
}
/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */
function normalizeMap(map) {
  if (!isValidMap(map)) {
    return []
  }
  return Array.isArray(map) ?
    map.map(function (key) { return ({ key: key, val: key }); }) :
    Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}




var mapState = function (states) {
  var res = {};
  assert(isValidMap(states), 'mapState: mapper parameter must be either an Array or an Object');
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState() {
      var state = this.$store.state;
      var getters = this.$store.getters;
      return typeof val === 'function' ?
        val(state, getters) :
        state[val]
    };
  });
  return res
};
/**
 * Reduce the code which written in Dative.js for getting the getters
 * @param {String} 
 * @param {Object|Array} getters
 * @return {Object}
 */
var mapGetters = function (getters) {
  var res = {};
  if (!isValidMap(getters)) {
    console.error('[dyte] mapGetters: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;
    res[key] = function mappedGetter() {
      if (!(val in this.$store.getters)) {
        console.error(("[dyte] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
  });
  return res
};

var mapActions = function (actions) {
  var res = {};
  if (!isValidMap(actions)) {
    console.error('[dyte] mapActions: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction() {
      var args = [], len = arguments.length;
      while (len--) args[len] = arguments[len];

      // get dispatch function from store
      var dispatch = this.$store.dispatch;
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
};

function unifyObjectStyle(type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  {
    assert(typeof type === 'string', ("expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function genericSubscribe(fn, subs, options) {
  if (subs.indexOf(fn) < 0) {
    options && options.prepend
      ? subs.unshift(fn)
      : subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}


var $$store;
function defineStore(options) {
  $$store = new Store(options);
  return $$store;
}
/**
 * @returns {Store}
*/
function useStore() {
  return $$store
}

/**
 * @param {object} options options for the Store
*/
function Store(options) {
  options = options || {};
  assert(this instanceof Store, "store must be called with the new operator.");
  var $this = this;
  $this.options = options;
  $this.actions = $this.options.actions || Object.create(null);
  $this.use = $this.options.use || Object.create(null);
  $this.subscriber = [];
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  this.dispatch = function boundDispatch(type, payload) {
    return dispatch.call(store, type, payload)
  };

  var $state = typeof $this.options.state === 'function' ? $this.options.state.apply($this, [$this]) : $this.options.state || Object.create(null);
  $this._state = new Proxy($state, {
    set(state, key, value) {
      state[key] = value;
      return true;
    }
  });

  for (const state in $this._state) {
    Object.defineProperty($this, state, {
      get: function reactivegetter() {
        return $this._state[state]
      },
      set: function reactivestatesetter(newValue) {
        $this._state[state] = newValue;
      },
      enumerable: true,
      configurable: true
    });
  }

  for (const action in $this.actions) {
    Object.defineProperty($this, action, {
      get: function reactiveactionsgetter() {
        return $this.actions[action]
      },
      enumerable: true,
      configurable: true
    });
  }

  if ($this.use === void 0) $this.use = [];

  var plugin_store = [];
  $this.installed_plugins = plugin_store;

  if (typeof $this.use === 'function' || Array.isArray($this.use)) {
    if (typeof $this.use === 'function') $this.use = $this.use();
    $this.use.forEach(function (plugins) {

      if (typeof plugins === 'function') {
        plugins($this);
        plugin_store.push(plugins($this));
      } else {
        Dative.warn('[Dyte warn]: Plugin should be a function');
      }
    });

  }

  $this.getters = {};
  const getters = $this.options.getters;
  if (!getters) return false;
  for (let key in getters) {
    const value = getters[key];
    Object.defineProperty($this.getters, key, {
      get: function reactivegetter() { return value.call(store) },
      enumerable: true,
      configurable: true,
    });
  }
}

var prototypeAccessors = { state: { configurable: true } };
prototypeAccessors.state.get = function () {
  return this._state
};

prototypeAccessors.state.set = function (v) {
  {
    assert(false, "use store.replaceState() to explicit replace store state.");
  }
};
Object.defineProperties(Store.prototype, prototypeAccessors);
/**
 * @param {string} _action for the actions
 * @param {string|object} _payload payload for the action
 **/
Store.prototype.dispatch = function dispatch(_action, _payload) {
  var store = this;
  var { type, payload } = unifyObjectStyle(_action, _payload);
  assert(this.actions[type], `action ${type} is undefined`);
  this.actions[type].call(store,
    {
      dispatch: store.dispatch,
      getters: store.getters,
      state: store.state
    },
    payload
  );

  this.subscriber.slice().forEach(subscribe => subscribe((this.state)));
};
/**
 * @param {function} fn subscribe to change in the mutations
 * @param {*} options
 **/
Store.prototype.subscribe = function subscribe(fn, options) {
  return genericSubscribe(fn, this.subscriber, options)
};

Store.prototype.replaceState = function replaceState(state) {
  var $this = this;
  $this._state = state;
};

var $destroy = function $destroy() {
  var $this = this;
  $this._state = Object.create(null);
  $this.actions = Object.create(null);
  $this.plugins = [];
  $this.getters = Object.create(null);
};
Store.prototype.$reset = function $reset() {
  var $store = this;
  $store.$destroy = $destroy;
  this.$destroy();
};
Store.prototype.hotUpdate = function hotUpdate(rawModule) {
  if (rawModule.actions) {
    this.actions = rawModule.actions;
  }
  if (rawModule.getters) {
    this.getters = rawModule.getters;
  }
};
/**
 * @param {Dative} dative installs Dyte to DativeJs
 **/
Store.prototype.install = function install(dative) {
  if (Dative) {
    tip(`Dyte is already installed. app.use(store) should be called only once.`);
    return;
  }
  var _this = this;
  dative.proto.$store = _this;
  setDative(dative.Dative);
};
/**
 * 
 * Re-renders the Dative instance whenever the Dyte Store changes 
*/

var connect = function connect() {
  /**
   * @param {typeof Dative} app
  */
  return (app) => {

    useStore().subscribe(() => app.render());
  }
};
var __VERSION__ = 'v1.0.1-alpha';

export { connect, defineStore, mapActions, mapGetters, mapState, useStore, __VERSION__ as version };
//# sourceMappingURL=dyte.esm.js.map
